import React from 'react';
import { type ReactNode, useEffect, useRef } from 'react';

import styles from './Modal.module.css';

export const Modal = ({
  content,
  footer,
  heading,
  isOpen = false,
  modalName,
  title,
  titleImage








}: {content?: ReactNode;footer?: ReactNode;heading?: ReactNode;isOpen: boolean;modalName: string;title: string;titleImage?: ReactNode;}) => {
  const modalRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (!modalRef.current) {
      return;
    }

    if (isOpen) {
      modalRef.current.showModal();
    } else {
      modalRef.current.close();
    }
  }, [modalRef, isOpen]);

  return (
    <dialog
      aria-label={`${modalName} - ${title}`}
      className={styles.dialog}
      ref={modalRef}>

			<div className={styles.content}>
				{heading}
				<div className={styles.textContainer}>
					<h2 className={titleImage ? styles['--hasImage'] : ''}>
						{titleImage}
						{title}
					</h2>
					{content}
				</div>
				{footer}
			</div>
		</dialog>);

};